<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />

<div class="layout-container">
  <img src="/assets/images/art_sessionexpired.svg" style="display:none;" alt="" />
  <header role="heading" aria-level="1">
    <app-header></app-header>
  </header>
  <main role="main" class="main-container">
    <app-error-modal></app-error-modal>
    <app-alert></app-alert>
    <app-loading></app-loading>
    <router-outlet></router-outlet>
    @if (timeInMins <= 10 && timeInSecs >= 0) {
      <app-modal-popup [custom]="true">
        <div class="session-popup">
          <div class="content">
            <div class="inner">
              <div class="clock">
                <img src="assets/images/art_sessionexpired.svg" class="clock-img" alt="Session timeout warning" />
              </div>
              <div class="warning-message">
                Due to inactivity, your session will time out in
              </div>
              @if (timeInSecs >= 60) {
                <div class="mins-secs-label">
                  {{timeInMins}} Minute@if (timeInMins !== 1) {
                  <span>s</span>
                }
              </div>
            }
            @if (timeInSecs < 60) {
              <div class="mins-secs-label">
                {{timeInSecs}} Second@if (timeInSecs !== 1) {
                <span>s</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="button-bar">
        <div class="button-container">
          <wdpr-button class="bottom" slot="buttons" theme="secondary" (click)="signOut()">
            Sign Out
          </wdpr-button>
          <wdpr-button class="d-flex bottom" slot="buttons" theme="primary" (click)="continueWorking()">
            Continue Working
          </wdpr-button>
        </div>
      </div>
    </div>
  </app-modal-popup>
}
</main>
</div>